export default function (state, val) {
    for (let k in val) {
        if (typeof state.form[k] !== 'undefined') state.form[k] = val[k];
    }
}